
export default {
    CHANGE_COUNT(state, value) {
        state.res_count = value;
    },
    CHANGE_MENULIST(state, value) {
        state.menuList = value;
    },
    CHANGE_USERINFO(state, value) {
        state.userInfo = value;
    },
    CHANGE_IsShow(state, value) {
        state.isShow = value;
    },
    CHANGE_USERS(state, value) {
        state.users = value;
    },
    CHANGE_ORGS(state, value) {
        state.orgs = value;
    },
    CHANGE_TITLE(state, value) {
        state.title = value;
    },
    CHANGE_ROLE_TITLE(state, value) {
      state.roleTitle = value;
  },
    CHANGE_NUM(state, value){
      state.num = value;
    },
    CHANGE_APPROVAL_NUM(state, value){
      state.approvalNum = value;
    },
    CHANGE_ORGONE(state, value) {
        state.orgOne = value;
    },
    CHANGE_SOCKET(state, value) {
        state.socket = value;
    },
    CHANGE_LOGOUT(state, value) {
        state.logout = value;
    },
    CHANGE_AUTHORID(state, value) {
        state.authorId = value;
    },
    CHANGE_RANDOM(state, value) {
        state.random = value;
    },
    CHANGE_SHOWFLOWCANVASNODE(state, value) {
        state.showFlowCanvasNode = value
    },
    CHANGE_SHOWFLOWCANVASDIALOG(state, value) {
        state.showFlowCanvasDialog = value
    },
    CHANGE_SHOWFLOWCANVASDELETE(state, value) {
        state.showFlowCanvasDelete = value
    },
    CHANGE_FORMFREESTYLE(state, value) {
        state.formFreestyle = value
    },
    CHANGE_FORMULA(state, value) {
        state.formula = value
    },
    CHANGE_ASSOCIATED(state,value){
       state.associated = value;
    },
    CHANGE_OAFORMITEM(state, value) {
        state.oaFormItem = value
    },
    CHANGE_OTHERLOGOUT(state, value) {
        state.otherLogout = value
    },
    CHANGE_CHANGEORG(state, value) {
        state.changeOrg = !state.changeOrg;
    },
    store_JsonString(state, value) {
        // console.log(value, 'store_JsonString')
        // console.log(state.JsonString, 'store_JsonString')
        if (value.key) {
            state.JsonString[value.key] = value.value;
        } else {
            state.JsonString = value;
        }
    },
    CHANGE_DRAG(state, value) {
        state.changeDrag = !state.changeDrag;
    },
    CHANGE_NOTICECLASSIFY(state, value) {
        state.noticeClassify = !state.noticeClassify
    },
    CHANGE_EDIT_OPTION(state, value) {
      state.editOption = value
  },

    SET_MSGNUM(state, msgNum) {
        state.msgNum = msgNum
    },
    ADD_MSGNUM(state, msgNum) {
        state.msgNum = msgNum
    },
    CUT_MSGNUM(state, msgNum) {
        if(state.msgNum > 0){
            state.msgNum = state.msgNum - 1
        }
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js